import React from 'react';
import './Pricing.css';
import SEO from '../components/SEO';
import { CONTACT_INFO } from '../constants';

function Pricing() {
  const handleCustomQuote = () => {
    const phoneNumber = CONTACT_INFO.PHONE.VALUE;
    const message = 'Get Custom Quote';
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleBookNow = (category, planType) => {
    const phoneNumber = CONTACT_INFO.PHONE.VALUE;
    const message = `Hi, I want to book a ${category} - ${planType}`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const pricingPlans = [
    {
      category: 'Matrimonial Ads',
      plans: [
        { type: 'Text Ad (3 lines)', price: '₹₹₹0*', features: ['Basic text ad', 'Single publication', 'Standard placement'] },
        { type: 'Text Ad (5 lines)', price: '₹₹₹0*', features: ['Extended text', 'Single publication', 'Bold heading'] },
        { type: 'Display Ad', price: '₹₹₹0*', features: ['Custom design', 'Photo included', 'Premium placement'] }
      ]
    },
    {
      category: 'Property Ads',
      plans: [
        { type: 'Text Ad', price: '₹₹₹0*', features: ['Up to 5 lines', 'Property details', 'Contact info'] },
        { type: 'Classified Display', price: '₹₹₹0*', features: ['Photo included', 'Highlighted border', 'Better visibility'] }
      ]
    },
    {
      category: 'Recruitment Ads',
      plans: [
        { type: 'Text Ad', price: '₹₹₹0*', features: ['Job description', 'Company name', 'Contact details'] },
        { type: 'Display Ad', price: '₹₹₹0*', features: ['Company logo', 'Custom design', 'Premium section'] }
      ]
    },
    {
      category: 'Public Notice',
      plans: [
        { type: 'Standard Notice', price: '₹₹₹0*', features: ['Legal format', 'Required documentation', 'Publication proof'] }
      ]
    }
  ];

  return (
    <div className="pricing-page">
      <SEO 
        title="Newspaper Ad Rates & Pricing Packages"
        description="Check latest newspaper advertisement rates for Matrimonial, Property, Recruitment ads. Save up to 20% on standard tariff rates."
        keywords="newspaper ad rates, times of india ad cost, hindu ad rates, matrimonial ad price, low cost newspaper ads"
        url="/pricing"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Pricing', url: '/pricing' }
        ]}
      />
      <section className="pricing-hero">
        <div className="container">
          <h1>Transparent Pricing</h1>
          <p className="lead">No hidden charges. 20% cheaper than competitors.</p>
        </div>
      </section>

      <section className="pricing-content">
        <div className="container">
          <div className="pricing-note">
            <h3>💡 Price Factors</h3>
            <p>Final pricing depends on:</p>
            <ul>
              <li>Newspaper selection (national/regional)</li>
              <li>Ad size and type (text/display)</li>
              <li>Publication date and edition</li>
              <li>Additional features (color, premium placement)</li>
            </ul>
          </div>

          {pricingPlans.map((section, index) => (
            <div key={index} className="pricing-category">
              <h2>{section.category}</h2>
              <div className="plans-grid">
                {section.plans.map((plan, planIndex) => (
                  <div key={planIndex} className="plan-card">
                    <h3>{plan.type}</h3>
                    {/* <div className="plan-price">{plan.price}</div> */}
                    <ul className="plan-features">
                      {plan.features.map((feature, featureIndex) => (
                        <li key={featureIndex}>✓ {feature}</li>
                      ))}
                    </ul>
                    <button className="book-now-btn" onClick={() => handleBookNow(section.category, plan.type)}>Book Now</button>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="custom-quote">
            <h2>Need a Custom Quote?</h2>
            <p>Contact our team for special packages and bulk bookings</p>
            <button className="contact-btn-large" onClick={handleCustomQuote}>Get Custom Quote</button>
          </div>

          <div className="payment-info">
            <h3>Payment Methods</h3>
            <p>We accept: Net Banking, UPI, Wallets</p>
            <p className="secure-badge">🔒 100% Secure Payments</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Pricing;
